import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../config/axios";
import { errorHandler } from "../../../helpers/handlers";

const initialState = {
  series: [],
  totals: null,
  byModel: {},
  from: null,
  to: null,
  pageLoading: false,
  error: null,
};

const slice = createSlice({
  name: "aiUsage",
  initialState,
  reducers: {
    clearUsageError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAiUsage.pending, (state) => {
        state.pageLoading = true;
        state.error = null;
      })
      .addCase(fetchAiUsage.fulfilled, (state, action) => {
        state.pageLoading = false;
        state.series = action.payload.series || [];
        state.totals = action.payload.totals || null;
        state.byModel = action.payload.byModel || {};
        state.from = action.payload.from || null;
        state.to = action.payload.to || null;
      })
      .addCase(fetchAiUsage.rejected, (state, action) => {
        state.pageLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearUsageError } = slice.actions;

export const fetchAiUsage = createAsyncThunk(
  "aiUsage/fetch",
  async ({ from, to } = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      if (from) params.set("from", from);
      if (to) params.set("to", to);
      const qs = params.toString();
      const response = await api.get(
        `/admin/ai/usage${qs ? `?${qs}` : ""}`
      );
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(
        error.response?.data?.errors?.global || error.message
      );
    }
  }
);

export default slice.reducer;
